import type { TrangThaiLuotCai } from '../types.ts';

export type TrangThaiCaiHienThi = 'da-cai' | 'dang-cai' | 'dang-go' | 'loi' | 'chua-cai';

/**
 * Trạng thái cài của một module trong tenant, gộp hai nguồn: danh sách module `ACTIVE` (`GET /api/v1/modules/installed`)
 * và lượt cài đang theo dõi sau khi bấm "Cài" (`GET /api/v1/modules/{code}/installation`). Lượt cài mới hơn thắng:
 * vừa bấm cài lại một module từng lỗi thì hiện "đang cài", không hiện lỗi cũ; vừa gỡ xong thì hiện "chưa cài" dù
 * danh sách đã cài chưa kịp tải lại.
 */
export function trangThaiCai(daCai: boolean, luotCai: TrangThaiLuotCai | undefined): TrangThaiCaiHienThi {
  if (luotCai === 'INSTALLING' || luotCai === 'UPGRADING') return 'dang-cai';
  if (luotCai === 'REMOVING') return 'dang-go';
  if (luotCai === 'FAILED') return 'loi';
  if (luotCai === 'REMOVED') return 'chua-cai';
  if (luotCai === 'ACTIVE' || daCai) return 'da-cai';
  return 'chua-cai';
}

/** Còn cần hỏi lại trạng thái lượt cài không: workflow cài, gỡ chạy tới 120 giây (ADR-0048). */
export function conTheoDoi(luotCai: TrangThaiLuotCai | undefined): boolean {
  return luotCai === undefined || luotCai === 'INSTALLING' || luotCai === 'UPGRADING' || luotCai === 'REMOVING';
}
